export const BLOCK_UI = 'BLOCK_UI';
export const RELEASE_UI = 'RELEASE_UI';

export const SET_GOOGLE_API = 'SET_GOOGLE_API';

export const SET_USER = 'SET_USER';
export const UNSET_USER = 'UNSET_USER';
export const SET_USER_KEY = 'SET_USER_KEY';

export const SET_SESSION_TIMEOUT = 'SET_SESSION_TIMEOUT';
export const UNSET_SESSION_TIMEOUT = 'UNSET_SESSION_TIMEOUT';

export const SET_UNAUTH_REDIRECT = 'SET_UNAUTH_REDIRECT';
export const UNSET_UNAUTH_REDIRECT = 'UNSET_UNAUTH_REDIRECT';

export const SET_CAMPAIGN_URL = 'SET_CAMPAIGN_URL';

export const SET_ACCOUNT_EXECUTIVE = 'SET_ACCOUNT_EXECUTIVE';



// WEBPACK FOOTER //
// ./src/vuex/types/mutations.js